import React from 'react';
import { Document } from '@react-pdf/renderer';
import type { AdmissionApplication, AdmissionCycle } from '../../../types/admissions';
import type { SchoolBranding, DocumentMeta, PhotoDataUrls } from '../../../utils/pdf';
import { AdmitCardSheet } from './AdmitCardDocument';

interface Props {
  apps: AdmissionApplication[];
  cycle: AdmissionCycle;
  branding: SchoolBranding;
  meta: DocumentMeta;
  photos?: PhotoDataUrls;
}

/**
 * AdmitCardBulkDocument — the print-day run: two cards per A4 sheet with a
 * cut guide. Each card is the same component as the single download, so a
 * parent gets an identical card whichever way it was printed.
 *
 * Guard note: at 150–200 cards the browser spends the pdf() tick on the
 * main thread — callers show PdfRenderingDialog while `loading` is true.
 */
const AdmitCardBulkDocument: React.FC<Props> = ({ apps, cycle, branding, meta, photos }) => {
  const sheets: AdmissionApplication[][] = [];
  for (let i = 0; i < apps.length; i += 2) sheets.push(apps.slice(i, i + 2));
  return (
    <Document title={meta.title} author={branding.name}>
      {sheets.map((pair) => (
        <AdmitCardSheet key={pair[0]._id} apps={pair} cycle={cycle} branding={branding} meta={meta} photos={photos} />
      ))}
    </Document>
  );
};

export default AdmitCardBulkDocument;
